<template>
    <div>
        <div>这是设施介绍网页</div>
    </div>
    
</template>
<script>
export default{
    name:"Facilities",
    data(){
        return{

        }
    }
}

</script>


// WEBPACK FOOTER //
// src/components/Facilities/Facilities.vue